<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <div class="row justify-content-end align-items-center">
              <div class="col-auto pr-0">
                <div class="d-flex flex-row">
                  <div class="mr-2 my-auto">
                    <label>{{ $t('to') }}:</label>
                  </div>
                  <div class="mr-2 my-auto">
                    <input type="date" v-model="to" class="form-control">
                  </div>
                </div>
              </div>
              <div class="col-auto pr-0">
                <CButton color="primary" @click="getClients">
                  <CIcon :content="$options.filterIcon" /> {{ $t('filter') }}
                </CButton>
              </div>
              <div class="col-auto pr-0">
                <CButton color="primary" @click="clearFilters">
                  <CIcon :content="$options.clearIcon" /> {{ $t('clear') }}
                </CButton>
              </div>
              <div class="col-auto pr-0 mr-3">
                <CButton color="primary" @click="printData()">
                  <CIcon :content="$options.printIcon" /> {{ $t('button.print') }}
                </CButton>
              </div>
            </div>
            <CDataTable
              :items="filteredItems"
              :fields="fields"
              :items-per-page="perPage"
              :itemsPerPageSelect="itemsPerPage"
              :tableFilter="tableFilter"
              :table-filter-value.sync="search"
              :loading="loading"
              hover
              sorter
              pagination
            >
            </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import listMixin from '../../mixins/list';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilFilter, cilClearAll, cilPrint } from '@coreui/icons';

export default {
  name: 'FollowUpClients',
  mixins: [listMixin, localeMixin],
  filterIcon: cilFilter,
  clearIcon: cilClearAll,
  printIcon: cilPrint,
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', label: i18n.t('fields.name') }, 
        { key: 'address', label: i18n.t('fields.address')},
        { key: 'phone', label: i18n.t('fields.phone')},
        { key: 'phone2', label: i18n.t('fields.phone2')},
        { key: 'comment', label: i18n.t('fields.comment')},
        { key: 'next_order', label: i18n.t('fields.next_order')},
        { key: 'last_order', label: i18n.t('fields.last_order')}
      ],
      you: null,
      showMessage: false,
      from: '',
      to: '',
      tableFilter: {
        label: i18n.t('search'),
        placeholder: i18n.t('clients.search_placeholder'),
        lazy: false,
        external: true
      },
      printUrl: ''
    }
  },
  computed: {
    filteredItems() {
      return this.items.filter(i => {
        return i.name.toLowerCase().includes(this.search.toLowerCase()) || 
        i.address.toLowerCase().includes(this.search.toLowerCase()) ||
        i.comment.toLowerCase().includes(this.search.toLowerCase()) ||
        i.phone.includes(this.search.toLowerCase() ||
        i.phone2.includes(this.search.toLowerCase()));
      });
    }
  },
  mounted() {
    this.getClients();
  },
  methods: {
    getClients() {
      this.items = [];
      let url = 'api/clients/followup?token=' + localStorage.getItem("api_token");

      if (this.from !== '') {
        url = url + '&from=' + this.from;
      }
  
      if (this.to !== '') {
        url = url + '&to=' + this.to;
      }

      this.printUrl = process.env.VUE_APP_API_ENDPOINT+url+'&print=true';
      url = '/'+url;
      axios.get(url)
      .then(response => {
        const data = response.data;
        if (data) {
            data.forEach(elem => {
              this.items.push({
                id: elem.id,
                name: elem.name,
                address: `${elem.address}, ${elem.address2}, ${elem.state}, ${elem.city}, ${elem.zipcode}`,
                phone: elem.phone,
                phone2: elem.phone2,
                comment: elem.comment === null ? '' : elem.comment,
                next_order: elem.next_order,
                last_order: elem.last_order
              });
          });
        }
      }).catch(error => {
        console.error(error);
      });
    },
    clearFilters() {
      this.to = '';
      this.getClients();
    },
    printData() {
      window.open(this.printUrl, '_blank');
    }
  }
}
</script>
